import React from "react";
// import "./Columns.css";
import Sedans from "./images/icon-sedans.svg";
import luxury from "./images/icon-luxury.svg";
import suvs from "./images/icon-suvs.svg";

const Car = ({ image, title, description, backgroundColor, color }) => {
  return (
    <article className="column" style={{ backgroundColor }}>
      <img src={image} alt={title} />
      <h2>{title}</h2>
      <p className="car-details">{description}</p>
      <button className="btn" style={{ color }}>
        Learn More
      </button>
    </article>
  );
};

const Column = () => {
  return (
    <section className="container">
      <Car
        image={Sedans}
        title="Sedans"
        description="
      Choose a sedan for its affordability and excellent fuel economy. Ideal
      for cruising in the city or on your next road trip.
      "
        backgroundColor="hsl(28, 81%, 54%)"
        color="hsl(28, 81%, 54%)"
      />
      <Car
        image={suvs}
        title="suvs"
        description="
      Choose a sedan for its affordability and excellent fuel economy. Ideal
      for cruising in the city or on your next road trip.
      "
        backgroundColor="hsl(185, 100%, 22%)"
        color="hsl(185, 100%, 22%))"
      />
      <Car
        image={luxury}
        title="luxury"
        description="
        Choose a sedan for its affordability and excellent fuel economy. Ideal
        for cruising in the city or on your next road trip.
        "
        backgroundColor="hsl(179, 100%, 13%)"
        color="hsl(179, 100%, 13%)"
      />
    </section>
  );
};
export default Column;
